import { BlogComponent } from './blog/blog.component';

export const pageComponents: any[] = [
  BlogComponent,
];

export * from './blog/blog.component';
